import { IResourceComponentsProps } from "@pankod/refine-core";
import { DATAPROVIDER_UPDATE } from "scripts/site";
import { RequestForm } from "./requestForm";

export const EditResourcingRequest: React.FC<IResourceComponentsProps> = () => {
    return (
        <RequestForm dataProvider={DATAPROVIDER_UPDATE} />
    );
};